import { render, staticRenderFns } from "./NotificacaoConfiguracao.vue?vue&type=template&id=01501548&"
import script from "./NotificacaoConfiguracao.vue?vue&type=script&lang=js&"
export * from "./NotificacaoConfiguracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports